import { a as allCountries } from '../constants/countryLists-D9DY8nsA.js';

const sanitizeCountries = countryList => countryList.filter(country => allCountries.includes(country));

export { sanitizeCountries as s };
//# sourceMappingURL=sanitizeCountries-erGcpLI_.js.map
